import React, { useState, useEffect } from "react";

const apiUrl = "https://localhost:7246/api/Tests";

interface Course {
  id: number;
  applyCoupon?: string;
  downloadFree?: string;
  buyCoupon?: string;
  // Add other properties as needed
}

export default function Cards() {
  const [courseData, setCourseData] = useState<Course[]>([]);

  useEffect(() => {
    // Fetch data from the API
    fetch(apiUrl)
      .then(response => response.json())
      .then(data => {
        if (data && data.result) {
          setCourseData(data.result);
        }
      })
      .catch(error => console.error("Error fetching data:", error));
  }, []);

  return (
    <div className="md:max-w-5xl mx-auto mt-5 mb-10 px-4 py-10">
      <div className="flex gap-14 flex-col lg:flex-row justify-center items-center">
        {courseData.map(course => (
          <><div key={course.id} className="flex flex-col justify-between gap-5 w-[230px] h-[450px]">
            <img
              src="/elearning/card1.png"
              alt="card"
              className="h-[273px] w-[210px]" />
            <div className="flex flex-col gap-4">
              <p className="text-2xl font-semibold leading-9 ">
              Enroll any course apply Coupon discount code.
              </p>
              {course.applyCoupon && (
                <div className="">
                  <a href={course.applyCoupon} target="_blank" rel="noopener noreferrer">
                    <button className="bg-primary px-3 py-2 text-white rounded-lg">
                      Apply Coupon
                    </button>
                  </a>
                </div>
              )}
            </div>
          </div><div className="flex flex-col justify-between gap-5 w-[230px] h-[450px]">
              <img
                src="/elearning/card2.png"
                alt="card"
                className="h-[273px] w-[210px]" />
              <div className="flex flex-col gap-4">
                <p className="text-2xl font-semibold leading-9 ">
                Downloading premium courses for free.
                </p>
                {course.downloadFree && (
                  <div className="">
                    <a href={course.downloadFree} target="_blank" rel="noopener noreferrer">
                      <button className="bg-secondary px-3 py-2 text-white rounded-lg">
                        Download Free
                      </button>
                    </a>
                  </div>
                )}
              </div>
            </div><div className="flex flex-col justify-between gap-5 w-[230px] h-[450px]">
              <img
                src="/elearning/card3.png"
                alt="card"
                className="h-[273px] w-[210px]" />
              <div className="flex flex-col gap-4">
                <p className="text-2xl font-semibold leading-9">
                Buy Recomanded or sponsored courses.
                </p>
                {course && (
                  <div className="">
                    <a href={course.buyCoupon} target="_blank" rel="noopener noreferrer">
                      <button className="bg-primary px-3 py-2 text-white rounded-lg">
                        Buy Course
                      </button>
                    </a>
                  </div>
                )}
              </div>
            </div></>
        ))}
      </div>
    </div>
  );
}
